import { render, staticRenderFns } from "./PacksInfo.vue?vue&type=template&id=497bf7a1&scoped=true&"
import script from "./PacksInfo.vue?vue&type=script&lang=js&"
export * from "./PacksInfo.vue?vue&type=script&lang=js&"
import style0 from "./PacksInfo.vue?vue&type=style&index=0&id=497bf7a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bf7a1",
  null
  
)

export default component.exports